const isMobile = () => document.documentElement.clientWidth <= 749;

function setLogoScale() {
    const scale = document.documentElement.clientWidth / 180;

    const rlLogo = document.getElementById("rl-logo");    
    if (rlLogo) {
        const logoHeight = rlLogo.getBoundingClientRect().height;
        const translateY = (logoHeight / scale) * 1.5;
        
        document.documentElement.style.setProperty('--logo-translate-y', `${translateY}px`);
    
        const heroSec = document.getElementById("heroSec")
        if(heroSec){
            // setting the margin to account for the logo
            heroSec.style.margin = `${logoHeight * scale * 0.9}px auto 0`;
        }
    }

    document.documentElement.style.setProperty('--logo-scale', scale);
}

function handleScroll() {
    const scrolled = window.scrollY > 10;
    if (!scrolled) return;

    const elements = {
        heroSec: document.getElementById("heroSec"),
        heroSecText: document.getElementById("heroSecText"),
        rlLogo: document.getElementById("rl-logo"),
        rotate: document.getElementById("rotate"),
        hand: document.getElementById("hand")
    };

    // Remove transform class from logo
    elements.rlLogo?.classList.remove("transform");

    // Apply different margins based on screen size
    if (document.documentElement.clientWidth <= 1440) {
        if (isMobile()) {
        elements.heroSec.style.marginTop = "24px";
        elements.heroSecText.style.marginTop = "0px";
        } else {
        elements.heroSec.style.marginTop = "40px";
        elements.heroSecText.style.marginTop = "28px";
        }
    } else {
        elements.heroSec.style.marginTop = "40px";
    }

    // Add animation classes
    elements.rotate?.classList.add("loading");
    elements.hand?.classList.add("move");
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
    if(!window.initIndexPage) return; 
    
    requestAnimationFrame(() => {
        setLogoScale()
    });

    document.addEventListener('scroll', handleScroll);
    document.addEventListener('touchmove', handleScroll, { passive: true });
    window.addEventListener('resize', setLogoScale);
});